import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";

interface AiToolCard {
	/**
	 * 进哪个工作台右栏的 Templates（effects-catalog.ts）：视频页只放 video，图片页只放 image。
	 * 不写就哪都不放：提示词工具（含 Veo Prompt）不出图，10/23 老公定不放
	 */
	kind?: "image" | "video";
	titleKey: string;
	descriptionKey: string;
	href: string;
	beforeImage: string;
	/** 有就画「原图 → 结果」对比，没有只放 beforeImage */
	afterImage?: string;
}

/**
 * 侧栏 AI Tools 页的两组（2026-10-23 老公定的归类）：改图类工具原来是生图页的 Templates tab，
 * 提示词类是原来的工具卡。AI Image Editor、Image to Video 侧栏都有入口，不再放这里；
 * 寸头、微笑、emoji 挪去 /ai-effects。组内按 9/22–10/22 浏览量排
 */
export const AI_TOOL_GROUPS: { labelKey: string; tools: AiToolCard[] }[] = [
	{
		labelKey: "common.footer.aiImageTools",
		tools: [
			{
				kind: "image",
				titleKey:
					"aiImageGenerator.templates.ai-clothes-changer.hero.title",
				descriptionKey:
					"aiImageGenerator.templates.ai-clothes-changer.hero.description",
				href: "/templates/ai-clothes-changer",
				beforeImage: buildR2AssetsImageUrl(
					"templates/ai-clothes-changer/carousel/input-tryon-model-2.webp",
				),
				afterImage: buildR2AssetsImageUrl(
					"templates/ai-clothes-changer/carousel/output-model-tryon-2.webp",
				),
			},
			{
				kind: "image",
				titleKey:
					"aiImageGenerator.templates.ai-pose-generator.hero.title",
				descriptionKey:
					"aiImageGenerator.templates.ai-pose-generator.hero.description",
				href: "/templates/ai-pose-generator",
				beforeImage: buildR2AssetsImageUrl(
					"templates/ai-pose-generator/use-cases/photography-before.webp",
				),
				afterImage: buildR2AssetsImageUrl(
					"templates/ai-pose-generator/use-cases/photography-after.webp",
				),
			},
			{
				kind: "image",
				titleKey:
					"aiImageGenerator.templates.getty-images-watermark-remover.hero.title",
				descriptionKey:
					"aiImageGenerator.templates.getty-images-watermark-remover.hero.description",
				href: "/templates/getty-images-watermark-remover",
				beforeImage: buildR2AssetsImageUrl(
					"templates/getty-images-watermark-remover/carousel/before-landscape.webp",
				),
				afterImage: buildR2AssetsImageUrl(
					"templates/getty-images-watermark-remover/carousel/after-landscape.webp",
				),
			},
			{
				kind: "image",
				titleKey:
					"aiImageGenerator.templates.ai-background-remover.hero.title",
				descriptionKey:
					"aiImageGenerator.templates.ai-background-remover.hero.description",
				href: "/templates/ai-background-remover",
				beforeImage: buildR2AssetsImageUrl(
					"templates/ai-background-remover/carousel/before-01.webp",
				),
				afterImage: buildR2AssetsImageUrl(
					"templates/ai-background-remover/carousel/after-01.webp",
				),
			},
			{
				kind: "image",
				titleKey:
					"aiImageGenerator.templates.virtual-staging-ai.hero.title",
				descriptionKey:
					"aiImageGenerator.templates.virtual-staging-ai.hero.description",
				href: "/templates/virtual-staging-ai",
				beforeImage: buildR2AssetsImageUrl(
					"templates/virtual-staging-ai/carousel/before-01.webp",
				),
				afterImage: buildR2AssetsImageUrl(
					"templates/virtual-staging-ai/carousel/after-01.webp",
				),
			},
		],
	},
	{
		labelKey: "common.footer.promptTools",
		tools: [
			{
				titleKey: "imageToPrompt.title",
				descriptionKey: "imageToPrompt.description",
				href: "/image-to-prompt",
				beforeImage: "/images/comparisons/boat-original.webp",
			},
			{
				titleKey: "batchImageToPrompt.title",
				descriptionKey: "batchImageToPrompt.description",
				href: "/batch-image-to-prompt",
				beforeImage: "/images/comparisons/astronaut-original.webp",
			},
			{
				titleKey: "aiDescribeImage.title",
				descriptionKey: "aiDescribeImage.description",
				href: "/ai-describe-image",
				beforeImage: "/images/comparisons/cyberpunk-girl-original.webp",
			},
			{
				titleKey: "aiOutfitDescriber.hero.title",
				descriptionKey: "aiOutfitDescriber.meta.description",
				href: "/ai-outfit-describer",
				beforeImage: "/images/tools/fashion-model.webp",
			},
			{
				titleKey: "veoPromptGenerator.title",
				descriptionKey: "veoPromptGenerator.description",
				href: "/veo-prompt-generator",
				beforeImage: "/images/tools/veo3-cover.webp",
			},
		],
	},
];
